import { render } from "./AgeSwitchComponent.vue?vue&type=template&id=177fca5a&scoped=true"
import script from "./AgeSwitchComponent.vue?vue&type=script&lang=js"
export * from "./AgeSwitchComponent.vue?vue&type=script&lang=js"

import "./AgeSwitchComponent.vue?vue&type=style&index=0&id=177fca5a&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177fca5a"]])

export default __exports__